import type {GetSelfStudentR200ResponseElaStandardSet} from '@freckle/fancy-api'
import {GetSelfStudentR200ResponseElaStandardSetFromJSON as parseJson} from '@freckle/fancy-api'

export interface RlStandardSetT extends GetSelfStudentR200ResponseElaStandardSet {
  // Plural versions of the labels from API where we simply add an 's'
  domainsLabel: string
  standardsLabel: string
  // The backend doesn't provide skills labels at all, but probably should. These are faked for now:
  skillLabel: string
  skillsLabel: string
}

export const parseAttrs = (json: unknown): RlStandardSetT => {
  const attrs = parseJson(json)
  return {
    ...attrs,
    domainsLabel: `${attrs.domainLabel}s`,
    standardsLabel: `${attrs.standardLabel}s`,
    skillLabel: 'skill',
    skillsLabel: 'skills'
  }
}
